// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ISortVariantSchema {
  /** Значение для варианта сортировки **/
  key: EKey;
  /** Отображаемый текст варианта сортировки  **/
  value: string;
}
export enum EKey {
  /** Заканчивается период действия **/
  'AboutToEnd' = 'aboutToEnd',
  /** Сначала новые **/
  'NewFirst' = 'newFirst',
  /** Популярные **/
  'Popularity' = 'popularity',
}
